import React from 'react';
import { GoogleIcon } from './Icons';

const LoginScreen = ({ onLogin, loading, sheetsService }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <div className="mx-auto h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
            <span className="text-blue-600 text-2xl">📚</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900">K12Core</h1>
          <p className="text-gray-600 mt-2">Student Signout Management System</p>
        </div>
        
        <div className="space-y-6">
          <div className="text-center">
            <p className="text-gray-600 mb-4">
              Sign in with your Google account to access your personalized signout management system.
            </p>
          </div>
          
          <button
            onClick={onLogin}
            disabled={loading}
            className="w-full flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
          >
            {loading ? (
              <>
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Connecting...
              </>
            ) : (
              <>
                <GoogleIcon className="w-5 h-5 mr-3" />
                Sign in with Google
              </>
            )}
          </button>
          
          <div className="text-center">
            <p className="text-xs text-gray-500">
              New users will automatically get their own spreadsheet setup
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
